import React from 'react'
import { manCheckingImg } from '../../images/TeleBindingImages/TeleBindingImages'

const DeclarationNotScreen = () => {
  return (
  <div className='declaration-screen'>
    <div className='declaration-content'>
        <div className='men-checking-img'>
          <img src={manCheckingImg} alt='Men Checking' />
        </div>
        <div className='men-content-text'>
          <h2>Thank you <br/> for your Submission!</h2>

          <p>
            Unfortunately, based upon your input,<br /> your purchase journey ends here.
            You<br /> may close this tab.
          </p>

          <span>
            For further assistance, please <br />connect with our seller.
          </span>
        </div>
    </div>
    <div>
    </div>
  </div>
  
  
  )
}

export default DeclarationNotScreen